// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bold-red {
    font-weight: bold;
    color: red;
}

.painel {
    position: sticky;
    /* top: 10px; */
    background-color: white;
    /* Defina uma cor de fundo, se necessário */
}

.tabela-container {
    font-size: 23px;
    /* Ajuste o tamanho da fonte conforme necessário */
}

/*
 * Regras para a cor da fonte da Barra de Progresso
 */

/* Por padrão, a fonte pode ser escura para ter bom contraste em fundos claros */
.progress-bar {
    color: #212529;
    /* Um preto suave */
    font-weight: 600;
    /* Opcional: deixa a fonte um pouco mais forte */
}

/* * Quando a barra de progresso tiver um fundo escuro
 * (como as variantes danger, success, info), 
 * mudamos a cor da fonte para branco para garantir o contraste.
*/
.progress-bar.bg-danger,
.progress-bar.bg-success,
.progress-bar.bg-info,
.progress-bar.bg-primary {
    color: white;
}

/* * A variante 'warning' (laranja/amarelo) é clara, 
 * então mantemos o texto escuro para melhor leitura.
 * Esta regra garante que o texto permaneça escuro mesmo que haja outras regras.
*/
.progress-bar.bg-warning {
    color: #212529;
}

/* Container principal que alinha os itens lado a lado */
.BarraDePgresso {
    display: flex;
    /* ESSA É A LINHA MAIS IMPORTANTE! Ativa o Flexbox. */
    align-items: center;
    /* Alinha verticalmente o texto e a barra no centro. */
    gap: 8px;
    /* Cria um espaço de 8px entre o texto e a barra. */
}

/* Estilo para o texto da porcentagem */
.BarraDePgresso .percentual-texto {
    /* font-weight: bold; */
    white-space: nowrap;
    /* Evita que o texto quebre a linha */
    min-width: 60px;
    /* Largura mínima para evitar que o layout "pule" */
}

/* Faz com que o componente da barra de progresso ocupe todo o espaço restante */
.BarraDePgresso .progress {
    /* O seletor .progress atinge o componente ProgressBar */
    flex-grow: 1;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Metas/index.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,kDAAkD;AACtD;;AAEA;;EAEE;;AAEF,gFAAgF;AAChF;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gDAAgD;AACpD;;AAEA;;;CAGC;AACD;;;;IAII,YAAY;AAChB;;AAEA;;;CAGC;AACD;IACI,cAAc;AAClB;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,qDAAqD;IACrD,mBAAmB;IACnB,sDAAsD;IACtD,QAAQ;IACR,mDAAmD;AACvD;;AAEA,uCAAuC;AACvC;IACI,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;IACf,mDAAmD;AACvD;;AAEA,gFAAgF;AAChF;IACI,wDAAwD;IACxD,YAAY;AAChB","sourcesContent":[".bold-red {\n    font-weight: bold;\n    color: red;\n}\n\n.painel {\n    position: sticky;\n    /* top: 10px; */\n    background-color: white;\n    /* Defina uma cor de fundo, se necessário */\n}\n\n.tabela-container {\n    font-size: 23px;\n    /* Ajuste o tamanho da fonte conforme necessário */\n}\n\n/*\n * Regras para a cor da fonte da Barra de Progresso\n */\n\n/* Por padrão, a fonte pode ser escura para ter bom contraste em fundos claros */\n.progress-bar {\n    color: #212529;\n    /* Um preto suave */\n    font-weight: 600;\n    /* Opcional: deixa a fonte um pouco mais forte */\n}\n\n/* * Quando a barra de progresso tiver um fundo escuro\n * (como as variantes danger, success, info), \n * mudamos a cor da fonte para branco para garantir o contraste.\n*/\n.progress-bar.bg-danger,\n.progress-bar.bg-success,\n.progress-bar.bg-info,\n.progress-bar.bg-primary {\n    color: white;\n}\n\n/* * A variante 'warning' (laranja/amarelo) é clara, \n * então mantemos o texto escuro para melhor leitura.\n * Esta regra garante que o texto permaneça escuro mesmo que haja outras regras.\n*/\n.progress-bar.bg-warning {\n    color: #212529;\n}\n\n/* Container principal que alinha os itens lado a lado */\n.BarraDePgresso {\n    display: flex;\n    /* ESSA É A LINHA MAIS IMPORTANTE! Ativa o Flexbox. */\n    align-items: center;\n    /* Alinha verticalmente o texto e a barra no centro. */\n    gap: 8px;\n    /* Cria um espaço de 8px entre o texto e a barra. */\n}\n\n/* Estilo para o texto da porcentagem */\n.BarraDePgresso .percentual-texto {\n    /* font-weight: bold; */\n    white-space: nowrap;\n    /* Evita que o texto quebre a linha */\n    min-width: 60px;\n    /* Largura mínima para evitar que o layout \"pule\" */\n}\n\n/* Faz com que o componente da barra de progresso ocupe todo o espaço restante */\n.BarraDePgresso .progress {\n    /* O seletor .progress atinge o componente ProgressBar */\n    flex-grow: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
